import { ReduceStore } from 'flux/utils';
import decode from 'jwt-decode';

import AppDispatcher from '../AppDispatcher';
import Auth0AmazonCredentials from '../util/Auth0AmazonCredentials';
import { IAM_ROLE, IAM_PROVIDER } from '../config/aws-config';

import Constants from '../Constants';

class TokenStore extends ReduceStore {
  getInitialState() {
    const idToken = localStorage.getItem('id_token') || null;
    const accessToken = localStorage.getItem('access_token') || null;
    if (idToken && accessToken) {
      return { idToken, accessToken };
    }
    return { idToken: null, accessToken: null };
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.USER_AUTHENTICATED:
        localStorage.setItem('id_token', action.authResult.idToken);
        localStorage.setItem('access_token', action.authResult.accessToken);
        return { idToken: action.authResult.idToken, accessToken: action.authResult.accessToken };
      case Constants.USER_LOGGED_OUT:
        localStorage.removeItem('id_token');
        localStorage.removeItem('access_token');
        return { idToken: null, accessToken: null };
      default:
        return state;
    }
  }

  isAuthenticated() {
    return !!this.getState().idToken;
  }

  getToken() {
    return this.getState().idToken;
  }

  getSubject() {
    return this.getDecodedToken().sub;
  }

  getDecodedToken() {
    return decode(this.getToken());
  }

  getAccessToken() {
    return this.getState().accessToken;
  }

  getAmazonCredentials() {
    return new Auth0AmazonCredentials(this.getToken(), IAM_ROLE, IAM_PROVIDER);
  }

  isGoogle() {
    return (this.getSubject().substring(0, 6) === 'google');
  }

}

const instance = new TokenStore(AppDispatcher);
export default instance;
